<template>
  <div>
    <div class="row form-group mt-4">
      <yes-or-no class="col-12" :model="model.employmentTime" />
    </div>

    <div v-if="model.employmentTime.$model" class="row form-group">
      <w-datepicker class="col-6" :model="model.employmentDataStart" />

      <w-datepicker class="col-6" :model="model.employmentDataEnd" />

      <w-textarea class="col-12 mt-4" :model="model.contractCancel" />
    </div>

    <div class="row form-group">
      <yes-or-no class="col-12" :model="model.otherEmployer" />
    </div>

    <w-form-table v-if="model.$model.otherEmployer">
      <thead>
        <tr>
          <th colspan="5">Pozostali pracodawcy</th>
        </tr>

        <tr>
          <th>Lp.</th>

          <th>Nazwa firmy</th>

          <th>Data rozpoczęcia pracy</th>

          <th>Data zakończenia pracy</th>

          <th />
        </tr>
      </thead>

      <tbody>
        <employers-row
          v-for="(item, index) in model.employers.$items"
          :key="'employers_' + index"
          :item="item.$item"
          :index="index"
        />
      </tbody>

      <tfoot>
        <tr>
          <td colspan="5">
            <w-add-row :model="model.employers" />
          </td>
        </tr>
      </tfoot>
    </w-form-table>

    <div class="row form-group">
      <div class="col-4">
        <w-datepicker :model="model.examDate" />
      </div>

      <div class="col-4">
        <w-input :model="model.certificateNumber" />
      </div>

      <div class="col-4">
        <w-input :model="model.commisionName" />
      </div>
    </div>

    <div class="row form-group">
      <div class="col-12">
        <person :model="model.practiceInstruktor" :set-title-as-placeholder="true" :has-address="false" />
      </div>
    </div>
  </div>
</template>

<script>
import { componentMixin } from '@/mixins/document/component';

import EmployersRow from './EmployersRow';
import Person from './Person';
import YesOrNo from './YesOrNoRadio';

// @vuese
// Employee component
// @Group formComponents
export default {
  components: {
    EmployersRow,
    Person,
    YesOrNo
  },
  mixins: [componentMixin]
};
</script>
